var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon3 = function SvgIcon3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#1E9646"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.99 19.76H9.37L8.95 21H7.16l2.54-7.02h1.98L14.22 21h-1.81zm-.44-1.32-.87-2.57-.86 2.57zm5.153-4.46V21h-1.71v-7.02z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M23.723 10.152a.328.328 0 0 1 .554 0l.373.587a5.26 5.26 0 0 0 1.612 1.61l.586.374a.328.328 0 0 1 0 .554l-.586.373a5.26 5.26 0 0 0-1.612 1.611l-.373.587a.328.328 0 0 1-.554 0l-.373-.587a5.26 5.26 0 0 0-1.612-1.61l-.586-.374a.328.328 0 0 1 0-.554l.586-.373a5.26 5.26 0 0 0 1.612-1.611z"
  })));
};
export default SvgIcon3;